import { getInicioCompetenciaAtual, getFimCompetenciaAtual } from './helpers';

const INITIAL_STATE = {
    creditosTelaInicial: [],
    creditos: null,
    loadingCreditos: false,
    error: null,
    dataInicio: getInicioCompetenciaAtual(),
    dataFim: getFimCompetenciaAtual(),
    error_elo: false,
    loadingImpressao: false,
    mensagem: "not_found",
    filterInicioPeriodo: { id: 1, label: "Janeiro" },
    filterFimPeriodo: { id: 12, label: "Dezembro" },
    msgErro: ''
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type){
        case 'HISCRE_CREDITOS_INICIAL':
            return {...state, loadingCreditos: false, loadingImpressao: false, error: null, mensagem: ''}
        case 'HISCRE_CREDITOS_SOLICITADOS':
            return {...state, loadingCreditos: true, loadingImpressao: false, error: false, error_elo: false, mensagem: '', 
                dataInicio: (action.payload ? action.payload.dataInicio : ""), dataFim: (action.payload ? action.payload.dataFim : "")};

        case 'HISCRE_CREDITOS_RECEBIDOS':
            let creditosTelaInicial = state.creditosTelaInicial;
            if(state.creditosTelaInicial===INITIAL_STATE.creditosTelaInicial){
                creditosTelaInicial=Array.isArray(action.payload.creditosTO) ? action.payload.creditosTO : [action.payload.creditosTO]
            }
        return {...state, 
            creditos: Array.isArray(action.payload.creditosTO) ? action.payload.creditosTO : [action.payload.creditosTO],
            creditosTelaInicial,
            loadingCreditos: false, loadingImpressao: false, mensagem: ''
        };

        case 'HISCRE_ERRO_RECEBIDO':
            return {...state, error: action.payload, loadingCreditos: false, loadingImpressao: false, creditos: null, mensagem: ''};

        case 'HISCRE_PERIODO_ALTERADO':
            return {...state, dataInicio: action.payload.dataInicio, dataFim: action.payload.dataFim, mensagem: ''};

        case 'HISCRE_IMPRESSAO_SOLICITADA':
            return {...state, loadingImpressao: true, error: false, error_elo: false, mensagem: ''};
            
        case 'HISCRE_IMPRESSAO_RECEBIDA':
            return {...state, loadingCreditos: false, loadingImpressao: false, error: false, error_elo: false, mensagem: 'sucesso'};

        case 'HISCRE_ERRO_IMPRESSAO_RECEBIDO':
            return {...state, loadingCreditos: false, loadingImpressao: false, error: true, error_elo: false, mensagem: ''};
                
        case 'HISCRE_ERRO_ELO':
            return { ...state, loadingCreditos: false, loadingImpressao: false, error: false.valueOf, error_elo: true, mensagem: '' };         

        case 'HISCRE_LIMPAR_MENSAGEM':
            return { ...state, loadingCreditos: false, loadingImpressao: false, error: false, error_elo: false, mensagem: "limpar", 
                dataInicio: "", dataFim: ""
            };

        case "HISCRE_CONSULTA_FILTER_INICIO_PERIODO":
            return { ...state, dataInicio: action.payload };    

        case "HISCRE_CONSULTA_FILTER_FIM_PERIODO":
            return { ...state, dataFim: action.payload };        
        case 'HISCRE_ERRO_INTERVALO_DATAS':
            return { ...state, loadingCreditos: false, loadingImpressao: false, error: true, mensagem: 'intervalo_erro', msgErro: action.payload};

        case 'HISCRE_ERRO_DATA_NAO_ENVIADA':
            return { ...state, loadingCreditos: false, loadingImpressao: false, error: true, mensagem: 'sem_data'};
        default:
            return state;
    }
}
